const Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        name: '',
        directory: true,
        diagrams: [],
        parentDirectory: null,
        edit: false,
        creating: false
    },

    isDeleted: function() {
        return this.get('deleted');
    },
});



// WEBPACK FOOTER //
// ./system/domain/entity/diagram-directory.js